import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as editingVariables from '../editing-variables'

import * as gql from './gql'
import type { TypeParams } from './types'

@ngCore.Injectable({ providedIn: 'root' })
export class Api implements ec.models.Api<TypeParams> {
  /** @see {@link editingVariables.Feature} */
  private readonly _editingVariablesFeature = ngCore.inject(
    editingVariables.Feature,
  )

  // TODO: The apps query returns a response of type { items: App[],
  // nextCursor?: string }. To align with the expected return type of the list
  // method (App[]), we map the response here.
  // Pagination by cursor should be implemented
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context =>
      context
        ? gql.queries.apps.execute(context).pipe(rxjs.map(({ items }) => items))
        : rxjs.of([]),
  )

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('name', {
        isSortable: true,
        name: 'Name',
      }),
      ec.models.Attribute.fromKey<TypeParams>('alias', {
        isSortable: true,
        name: 'Alias',
      }),
      ec.models.Attribute.fromKey<TypeParams>('description', {
        name: 'Description',
      }),
    ])

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (context, input) => {
    TypeAsserter.assertIsNotNullish(context)
    const variables =
      this._editingVariablesFeature.selectors.definitionsList.asSignal()

    input = {
      ...input,
      sessionVariables: variables,
    }
    return gql.mutations.createApp.executor({
      input: gql.inputs.app.INPUT.getGqlFrom(input),
      ...context,
    })
  }

  /** @inheritdoc */
  public update: ec.models.Api<TypeParams>['update'] = (
    context,
    { id, updates },
  ) => {
    TypeAsserter.assertIsNotNullish(context)
    const variables =
      this._editingVariablesFeature.selectors.definitionsList.asSignal()
    updates = {
      ...updates,
      sessionVariables: variables,
    }
    return gql.mutations.updateApp.executor({
      tenantId: context.tenantId,
      updateAppId: id,
      updates: gql.inputs.app.UPDATES.getGqlFrom(updates),
      zoneId: context.zoneId,
    })
  }

  /** @inheritdoc */
  public delete: ec.models.Api<TypeParams>['delete'] = (context, id) => {
    TypeAsserter.assertIsNotNullish(context)
    return gql.mutations.deleteApp.executor({
      ...context,
      deleteAppId: id,
    })
  }
}
